export default __webpack_public_path__ + "static/media/quiz-q7.9fc6f927.png";